/* eslint-disable import/no-extraneous-dependencies */
import React, { RefObject } from "react";
import { ClickAwayListener, Popper } from "@mui/material";
import { DateRangePicker, Range, RangeKeyDict } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

type DateRangeDialogProps = {
  anchorEl: RefObject<HTMLElement>;
  open: boolean;
  onClose: () => void;
  dateRangeFilter: Range[];
  onDateRangeChanged: (newDateRangeFilter: Range[]) => void;
};

function normalizeDateRangeFilter(dateRangeFilter: Range[]): Range[] {
  const isStartDateMissing = !dateRangeFilter[0].startDate;
  const isEndDateMissing = !dateRangeFilter[0].endDate;

  if (isStartDateMissing && isEndDateMissing) {
    const today = new Date();
    return [
      {
        startDate: today,
        endDate: today,
        key: "selection",
      },
    ];
  }

  return dateRangeFilter;
}

const DateRangeDialog: React.FC<DateRangeDialogProps> = ({
  anchorEl,
  open,
  onClose,
  dateRangeFilter,
  onDateRangeChanged,
}) => {
  const handleChange = (ranges: RangeKeyDict) => {
    onDateRangeChanged([ranges.selection]);
  };

  const dateFilter = normalizeDateRangeFilter(dateRangeFilter);

  return (
    <Popper
      data-testid="data-range-dialog"
      open={open}
      anchorEl={anchorEl.current}
      placement="bottom-start"
      style={{ zIndex: 1300 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <div className="mt-2 bg-white rounded-2xl shadow-lg p-4 custom-date-range-wrapper subtitle2">
          <style>{`
          .custom-date-range-wrapper .rdrInputRanges {
            display: none !important;
          }
          .custom-date-range-wrapper .rdrDefinedRangesWrapper {
            width: 120px !important;
          }
          .custom-date-range-picker .rdrStartEdge,
          .custom-date-range-picker .rdrEndEdge,
          .custom-date-range-picker .rdrInRange {
            background-color: #0C8E77 !important;
          }
        `}</style>
          <DateRangePicker
            onChange={handleChange}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={dateFilter}
            direction="horizontal"
            className="custom-date-range-picker"
          />
        </div>
      </ClickAwayListener>
    </Popper>
  );
};

export default DateRangeDialog;
